export default "__VITE_ASSET__nvEJCZDp__"